import { render, staticRenderFns } from "./basicInformation.vue?vue&type=template&id=0dafd376&scoped=true&"
import script from "./basicInformation.vue?vue&type=script&lang=js&"
export * from "./basicInformation.vue?vue&type=script&lang=js&"
import style0 from "./basicInformation.vue?vue&type=style&index=0&id=0dafd376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dafd376",
  null
  
)

export default component.exports